module.exports = __webpack_public_path__ + "img/JD approval.3b1f1295.svg";